(function () {
  function initials(name) {
    if (!name) return '?';
    var parts = name.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    var first = parts[0][0] || '';
    var second = parts.length > 1 ? parts[1][0] : '';
    return (first + second).toUpperCase();
  }

  function decorate(wrap) {
    wrap.setAttribute('data-mob-avatar', '1');
    var nameEl = wrap.querySelector('.jdgm-carousel-item__reviewer-name');
    var timeEl = wrap.querySelector('.jdgm-carousel-item__timestamp');
    var name = nameEl ? nameEl.textContent.trim() : '';

    var avatar = document.createElement('div');
    avatar.className = 'mob-review-avatar';
    avatar.textContent = initials(name);

    var meta = document.createElement('div');
    meta.className = 'mob-review-meta';
    if (nameEl) meta.appendChild(nameEl);
    if (timeEl) meta.appendChild(timeEl);

    wrap.textContent = '';
    wrap.appendChild(avatar);
    wrap.appendChild(meta);
    wrap.classList.add('mob-review-avatar-wrap');
  }

  function scan(root) {
    var wraps = root.querySelectorAll('.jdgm-carousel-item__reviewer-name-wrapper:not([data-mob-avatar])');
    wraps.forEach(decorate);
  }

  function start() {
    var carousels = document.querySelectorAll('.jdgm-carousel');
    carousels.forEach(function (carousel) {
      scan(carousel);
      if (carousel.__mobAvatarObserver) return;
      var observer = new MutationObserver(function () { scan(carousel); });
      observer.observe(carousel, { childList: true, subtree: true });
      carousel.__mobAvatarObserver = observer;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Judge.me's widget can attach well after DOMContentLoaded; keep checking briefly.
  var tries = 0;
  var poll = window.setInterval(function () {
    start();
    tries += 1;
    if (tries > 20) window.clearInterval(poll);
  }, 500);
})();
